<template>
  <div class="table table--hero slicing-profiles">
    <b-table :fields="fields" :items="profilesList" primary-key="id">
      <template v-slot:cell(active)="data">
        <slicing-profile-enable-switcher :profile-id="data.item.id" profile-name="data.item.name"
                                         :enabled="data.item.enabled === 't'"></slicing-profile-enable-switcher>
      </template>
      <template v-slot:cell(name)="data" class="title">
        <slicing-profile-name :profile-id="data.item.id" :profile-name="data.item.name"></slicing-profile-name>
      </template>
      <template v-slot:cell(dateTime)="data">
        <date-time-text :date="data.item.updated_date"></date-time-text>
      </template>
      <template v-slot:cell(actions)="data">
        <b-button variant="-primary btn--outline" size="-small" v-if="isOrgAdmin"
                  @click="handleOpenRightsPopup(data.item)">{{$t('profiles.actions.access')}}
        </b-button>
        <b-button variant="-primary" size="-small" @click="handleEdit(data.item)">{{$t('profiles.actions.edit')}}</b-button>
        <b-button variant="-primary" size="-small" v-if="canMakeDefault" @click="handleMakeDefault(data.item)">{{$t('profiles.actions.makeDefault')}}</b-button>
        <slicing-profile-delete-button :profile-id="data.item.id"
                                       :profile-name="data.item.name"></slicing-profile-delete-button>
      </template>
    </b-table>

    <b-modal v-model="openRightsPopup" size="lg">
      <slicing-profile-rights-form ref="rightsForm" :profile="editRightsProfile"></slicing-profile-rights-form>
      <template v-slot:modal-footer="{ cancel, ok }">
        <div class="modal__footer--left">
          <b-button variant="-gray" @click="cancel()">
            {{$t('buttons.cancel')}}
          </b-button>
        </div>
        <div class="modal__footer--right">
          <b-button variant="-primary" @click="handleSaveRights(ok)">
            {{$t('buttons.save')}}
          </b-button>
        </div>
      </template>
    </b-modal>
    
    <b-modal v-model="openMakeDefaltPopup">
      <p>{{$t('profiles.makeDefaultNamePopupText')}}</p>
      <b-form-group class="mt-2">
        <lable>{{$t('profiles.makeDefaultNamePopupNameField')}}</lable>
        <b-form-input class="inp" style="width: 100%" v-model="makeDefaultName"></b-form-input>
      </b-form-group>
      <template v-slot:modal-footer="{ cancel, ok }">
        <div class="modal__footer--left">
          <b-button variant="-gray" @click="cancel()">
            {{$t('buttons.cancel')}}
          </b-button>
        </div>
        <div class="modal__footer--right">
          <b-button variant="-primary" @click="handleApplyMakeDefault(ok)">
            {{$t('profiles.makeAsDefaultButton')}}
          </b-button>
        </div>
      </template>
    </b-modal>

    <slicer3 v-if="slicer3Show" :show="slicer3Show" :profile-id="slicer3ProfileId" :printer-type-id="slicer3PrinterTypeId" profile-mode
             @hide="slicer3Show=false"></slicer3>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";
  import SlicingProfileEnableSwitcher from "./SlicingProfileEnableSwitcher";
  import SlicingProfileName from "./SlicingProfileName";
  import DateTimeText from "../DateTimeText";
  import SlicingProfileRightsForm from "./modal/SlicingProfileRightsForm";
  import SlicingProfileDeleteButton from "./SlicingProfileDeleteButton";

  import ApplicationMixin from "@/mixins/application";
  import Slicer3 from "../apps/slicer3/Slicer3";

  export default {
    name: 'slicing-profiles-active-table',
    mixins: [ApplicationMixin],
    components: {
      Slicer3,
      SlicingProfileDeleteButton,
      SlicingProfileRightsForm,
      DateTimeText, SlicingProfileName, SlicingProfileEnableSwitcher
    },
    props: {
      search: {
        type: String
      }
    },
    data() {
      return {
        openRightsPopup: false,
        editRightsProfile: {},
        slicer3Show: false,
        slicer3ProfileId: null,
        slicer3PrinterTypeId: null,
        
        submitting: false,
        openMakeDefaltPopup: false,
        makeDefaultProfile: null,
        makeDefaultName: null,
      }
    },
    computed: {
      ...mapGetters(['getProfiles', 'isOrgAdmin', 'isOemAdmin']),

      fields() {
        let fields = [];
        if (this.isOrgAdmin) {
          fields.push({key: 'active'});
        }
        fields.push({key: 'name', class: 'name'});
        //fields.push({key: 'slicer_id', formatter: this.slicerNameById, class: 'id'});
        fields.push({key: 'printer_type', class: 'printer'});
        fields.push({key: 'dateTime', class: 'date'});
        // if (this.isOrgAdmin) {
        //     fields.push({key: 'priority'});
        // }
        fields.push({key: 'actions', class: 'actions'});

        return fields;
      },

      searchText() {
        return this.search ? this.search.trim() : '';
      },

      profilesList() {
        return this.getProfiles.filter(profile => {
          if (profile.deleted_by !== null || profile.is_default === 't') {
            return false;
          }
          if (!this.searchText) {
            return true;
          }
          return profile.name.indexOf(this.searchText) >=0 ||
              profile.printer_type.indexOf(this.searchText) >=0 ||
              this.slicerNameById(profile.slicer_id).indexOf(this.searchText) >= 0;
        });
      },
      
      canMakeDefault() {
        return this.isOemAdmin;
      }
    },
    methods: {
      ...mapActions(['makeProfileAsDefault', 'deleteProfile']),
      
      handleOpenRightsPopup(profile) {
        this.editRightsProfile = profile;
        this.openRightsPopup = true;
      },

      handleSaveRights(ok) {
        this.$refs.rightsForm.handleUpdateWorkgroupRights();
        ok();
      },

      handleEdit(profile) {
        switch (parseInt(profile.slicer_id)) {
          case 3:
            this.oldApps_showCloudSlicer(profile.id, profile.printer_type_id, 'profile', profile.name);
            break;
          case 48:
            this.oldApps_showCloudMbotSlicer(profile.id, profile.printer_type_id, 'profile', profile.name);
            break;
          case 51: {
            this.slicer3ProfileId = profile.id;
            this.slicer3PrinterTypeId = profile.printer_type_id;
            this.slicer3Show = true;
          }
            break;
        }
      },
      
      handleMakeDefault(profile) {
        this.makeDefaultProfile = profile;
        this.makeDefaultName = profile.name;
        this.openMakeDefaltPopup = true;
      },

      handleApplyMakeDefault(ok) {
        ok();
        const sendMakeDefaultRequest = () => {
          this.submitting = true;
          this.makeProfileAsDefault({profileId: this.makeDefaultProfile.id, name: this.makeDefaultName})
            .then(({data}) => {
              this.submitting = false;
              if (data.result) {
                this.msgBoxConfirm(this.$t('profiles.confirmRemoveAfterMakeDefault')).then((val) => {
                  if (!val) return;
                  this.deleteProfile(this.makeDefaultProfile.id).then(({data}) => {
                    if (!data.result) {
                      this.toast(this.$t('profiles.failedToDeleteProfile') + ': ' + data.message);
                    }
                  })
                });
              } else {
                this.toast(data.message);
              }
            })
            .catch(() => {
              this.submitting = false;
            });
        };
        const replace = this.getProfiles.filter(profile => {
          return profile.is_default === 't' && !profile.deleted_by && 
            profile.printer_type_id === this.makeDefaultProfile.printer_type_id && 
            profile.slicer_id === this.makeDefaultProfile.slicer_id && 
            profile.name.trim().toLowerCase() === this.makeDefaultName.trim().toLowerCase()
        }).length > 0;
        if (replace) {
          this.msgBoxConfirm(this.$t('profiles.confirmMakeDefaultReplace', {name: '"'+this.makeDefaultName+'"'})).then((val) => {
            if (val) {
              sendMakeDefaultRequest();
            }
          });
        } else {
          sendMakeDefaultRequest();
        }
      }
    }
  }
</script>

<style lang="scss">
  .slicing-profiles {
    tr {
      td{
        &:first-child {
          flex-grow: 1 !important;
          max-width: unset;
          width: 15%;
        }
      }
    }

    &.table, .table {
      padding: 0;
      margin: 0;
    }

    table {

      thead {
        display: none;
      }

      tr {
        min-height: 48px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        td {
          flex-grow: 1;
          max-width: 20%;

          &:first-child {
            flex-grow: 0;
            max-width: unset;
            width: fit-content;
          }
        }

        .name {
          font-weight: 500;
          //max-width: 20%;
          width: 20%;
          margin-right: auto;
        }

        .date {
          margin-right: auto;
        }

        .deleted_by {
          max-width: 20%;
          word-break: break-all;
        }

        .actions {
          flex-grow: 0;
          max-width: unset;
          .btn {
            margin-left: 8px;
          }
          .icon--trash {
            height: 20px;
            width: 20px;
            left: -1px;
            top: -2px;
          }
        }


      }
    }

  }
</style>
